/*
 * @Author: mrlthf11
 * @LastEditors: mrlthf11
 * @Date: 2021-08-17 15:54:32
 * @LastEditTime: 2022-03-10 15:47:39
 * @Description: file content
 */

import { requestCreator } from 'lth-tools/es';
import axios from 'axios';

axios.defaults.timeout = 10000;

const devBase = 'http://qypt.shasteel.cn/onlineTest'
const prodBase = '/onlineTest'

export const baseURL = process.env.NODE_ENV === 'development' ? devBase : prodBase

export const { request, cancel } = requestCreator({
    baseURL,
    headers: {
        get 'userId'() {
            return localStorage.getItem('userId')
        }
    },
    onStatusError(resp) {
        const statusMsg = {
            400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
            401: '用户没有权限（令牌、用户名、密码错误）。',
            403: '用户得到授权，但是访问是被禁止的。',
            404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
            406: '请求的格式不可得。',
            410: '请求的资源被永久删除，且不会再得到的。',
            422: '当创建一个对象时，发生一个验证错误。',
            500: '服务器发生错误，请检查服务器。',
            502: '网关错误。',
            503: '服务不可用，服务器暂时过载或维护。',
            504: '网关超时。',
        }

        const msg = resp.data.error ?? statusMsg[resp.status] ?? `网络错误 ${resp.status}`

        throw new Error(msg);
    },

});

export const postFile = (url, params) => {
    const fd = new FormData();
    Object.keys(params).forEach((k) => {
        fd.append(k, params[k]);
    })
    return fetch(baseURL + url, {
        method: 'POST',
        body: fd,
        // FormData 会自动生成合法的实体数据，无需添加头，添加后反而会导致服务器无法识别
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        // },
    }).then((res) => res.json())
}
